import { useAbility } from "@/casl-provider";
import { generateUuidV4Regex } from "@/common/helpers/utils";
import { InitRoutes } from "@/modules/fit/internal/relocation-order/init/init.routes";
import { AdminCreateView } from "@/modules/fit/internal/relocation-order/admin/create/admin-create.view";
import { AdminSelectVehicleView } from "@/modules/fit/internal/relocation-order/admin/create/admin-select-vehicle.view";
import { AdminUpdateView } from "@/modules/fit/internal/relocation-order/admin/update/admin-update.view";
import { BcaCreateView } from "@/modules/fit/internal/relocation-order/bca/bca-create.view";
import { RelocationOrderView } from "@/modules/fit/internal/relocation-order/relocation-order.view";
import { RelocationOrderDetailView } from "@/views/relocation-order-detail/relocation-order-detail.view";
import { Redirect, Route, Switch } from "wouter";

export function RelocationOrderRoutes() {
  const ability = useAbility();
  const canManage = ability.can("manage", "RelocationOrder");
  const relocationOrderUuidRegex = generateUuidV4Regex({
    paramName: "uuid",
  });
  const relocationOrderUuidUpdateRegex = generateUuidV4Regex({
    paramName: "uuid",
    suffix: "/update",
  });

  return (
    <Switch>
      <Route path={relocationOrderUuidRegex} component={RelocationOrderDetailView} />
      <Route path="/" component={RelocationOrderView} />
      <Route path="/bca-create" component={BcaCreateView} />
      <Route nest path="/init" component={InitRoutes} />
      {canManage && <Route path="/create/select-vehicle" component={AdminSelectVehicleView} />}
      {canManage && <Route path="/create" component={AdminCreateView} />}
      {canManage && <Route path={relocationOrderUuidUpdateRegex} component={AdminUpdateView} />}
      <Redirect to="/" replace />
    </Switch>
  );
}
